import { dashboardReduxReducerActions } from "@/redux/actions/dashboard";
import { RetryGetOrderSteps } from "@/redux/reducers/dashboard";
import { useAppDispatch, useAppTranslation, useBackToShop } from "@/utils";
import { CloseCircleFilled, PhRArrowCounterClockwise } from "@payping/icons";
import { Button, Flex, Typography } from "@payping/web-components";

const PayGetOrderUploadSignatureUnAvailable = () => {
  const { t } = useAppTranslation();
  const dispatch = useAppDispatch();

  const { backToShop, shopName } = useBackToShop();

  return (
    <Flex vertical className="tw:h-full tw:w-full tw:p-4!" gap={"middle"} align="center">
      <Flex vertical align="center" justify="center" gap={"large"} className="tw:mt-auto tw:w-full">
        <CloseCircleFilled width={80} className="tw:fill-color-error" />
        <Flex vertical gap={"small"} align="center" justify="center" className="tw:text-center">
          <Typography.Title level={5} className="tw:m-0! tw:font-semibold!">
            {t("pay.getOrder.steps.uploadSignature.unAvailableTitle")}
          </Typography.Title>
          <Typography.Text type="secondary" className="tw:text-center">
            {t("pay.getOrder.steps.uploadSignature.unAvailableContent")}
          </Typography.Text>
        </Flex>
        <Button
          type="link"
          icon={<PhRArrowCounterClockwise width={14} height={14} />}
          onClick={() => {
            dispatch(dashboardReduxReducerActions.setRetryGetOrder(RetryGetOrderSteps.startGetOrder));
          }}
        >
          {t("common.retry")}
        </Button>
      </Flex>

      <Flex align="center" className="tw:mt-auto tw:w-full" gap={"middle"}>
        <Button
          block
          onClick={() => {
            backToShop();
          }}
        >
          {t("common.returnTo", { name: shopName })}
        </Button>
      </Flex>
    </Flex>
  );
};

export default PayGetOrderUploadSignatureUnAvailable;
